import { Info } from 'lucide-react'

export const StepsInfo = () => (
  <p className="self-end pt-8 pb-[56px] text-slate-700 text-xs relative">
    <Info className="text-slate-400 mr-[4px] size-[13px] relative top-[-1px] inline-block" />
    Claravine leverages AI to analyze, detect, and reconcile variations in your data. Your original
    data will remain unchanged — instead, a new translated taxonomy will be generated. Your data is
    safeguarded and will only be used to train AI technologies exclusively for your organization.
  </p>
)
